import axios from "axios";
import Session from "../helpers/SessionHelper";
import { GET_GEO_JSON } from "../../src/configurations/Urls";

const GisLayerService = {
  async loadAllIrrigationFields() {
    const headers = await Session.getHeaderWithToken();
    const response = await axios.get(GET_GEO_JSON, {
      headers: headers,
    });
    let geoJsonData = response.data.data;
    return geoJsonData;
  },
};
export default GisLayerService;
